<template>
  <el-dialog title="通用审批申请" :visible.sync="show" :before-close="close" center destroy-on-close>
    <el-form ref="form" :rules="rules" :model="info" label-width="22%">
      <el-row>
          <el-col :span="24">
            <el-form-item label="编号" prop="eventId" v-if="type !== 'new'">
              <el-input disabled placeholder="编号" show-word-limit v-model="info.eventId" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="申请标题" prop="applyTitle">
              <el-input :disabled="type !== 'new'" placeholder="申请标题" show-word-limit v-model="info.applyTitle" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="申请内容" prop="applyContent" >
              <el-input :disabled="type !== 'new'" type="textarea" :rows="5" placeholder="请输入申请原因" maxlength="200"
                show-word-limit v-model="info.applyContent" />
            </el-form-item>
          </el-col>
        <template v-if="auditInfo.approvalFlag">
          <el-col :span="24">
            <el-form-item label="审核状态" prop="status" :rules="{
              required: true, message: '请选择审核状态', trigger: 'change'
            }">
              <el-select v-model="info.status" @change="handleRemark">
                <el-option :value="item.value" :label="item.label"  v-for="(item,index) in statusOptions" :key="index"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="审核原因">
              <el-input type="textarea" :rows="3" placeholder="请输入审核原因" @input="changeMessage($event)"
                v-model="info.remark" />
            </el-form-item>
          </el-col>
        </template>
        <template v-if="type === 'new' || info.status === 0">
          <el-col :span="24">
            <approvalRadio  v-model="isSubmitApproval" v-show="type === 'new'" />
          </el-col>
          <el-col :span="24">
            <el-form-item label="下一级审核人" prop="auditPersonId" v-if="activeName == 'queryMine'">
              <el-select v-model="info.auditPersonId" placeholder="请选择" clearable filterable :disabled="type !== 'new'">
                <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="下一级审核人" prop="auditPersonId" v-else>
            <el-input v-model="this.info.auditPerson" disabled />
          </el-form-item>
          </el-col>
        </template>
        <template v-if="activeName == 'queryMyAudit'">
          <el-col :span="24">
            <el-form-item label="是否结束审核" prop="lastUserFlag" v-if="info.status == '1'">
              <el-radio v-model="info.lastUserFlag" :label="1">是</el-radio>
              <el-radio v-model="info.lastUserFlag" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <approvalRadio  v-model="isSubmitApproval" v-show="info.status == '1' && info.lastUserFlag == 0"/>
          </el-col>
          <el-col :span="24">
            <el-form-item label="下一级审核人" prop="nextAuditUserName" v-if="info.status == '1' && info.lastUserFlag == 0">
              <el-select v-model="info.nextAuditUserName" placeholder="请选择" clearable filterable>
                <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <approvalRadio  v-model="isSubmitApproval" v-show="info.status == '3'"/>
          </el-col>
          <el-col :span="24">
            <el-form-item label="转办人" prop="nextAuditUserName" v-if="info.status == '3'">
              <el-select v-model="info.nextAuditUserName" placeholder="请选择" clearable filterable>
                <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
    </el-form>
    <review-process v-show="type !== 'endUseCar'" :processList="auditInfo.auditProcessEntityList"
      :createTime="auditInfo.createTime" :createUser="auditInfo.applyUser" :auditPerson="auditInfo.auditPerson" />
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="addEventForm()" v-if="type === 'new' || auditInfo.approvalFlag">提 交</el-button>
      <el-button type="primary" @click="addStagingForm()" v-if="(actionType === 'new' || info.status === 10)">暂
        存</el-button>
      <el-button @click="close">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { submitApply, auditAndNextUser, getApplyDetail, update, stagingApply } from '@/api/compApplyCommon.js'
import ReviewProcess from '@/components/ReviewProcess.vue'
import { validPhone } from '@/assets/scripts/validate'
// import { queryUserInfo } from '@/api/basicInfo'
import approval from '@/mixins/approval'
export default {
  mixins: [approval],
  components: {
    ReviewProcess
  },
  data() {
    return {
      timeValue: [],
      info: {
        applyContent: '',
        applyTitle: '',
        eventId: '',

        lastUserFlag: '',
        nextAuditUserName: '',
        auditPersonId: '',
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      carList: [],
      statusOptions: [
        {
          value: '1',
          label: '通过'
        },
        {
          value: '2',
          label: '拒绝'
        },
        {
          value: '3',
          label: '转办'
        },
        {
          value: '4',
          label: '退回上一级'
        },
      ],
      rules: {
        applyContent: [{ required: true, message: '请输入', trigger: 'change' }],
        applyTitle: [{ required: true, message: '请输入', trigger: 'change' }],
        begin: [{ required: true, message: '请选择使用周期', trigger: 'change' }],
        distance: [{ required: true, message: '请输入公里数', trigger: 'blur' }],
        driver: [{ required: true, message: '请输入驾驶员', trigger: 'blur' }],
        driverTel: [{ required: true, message: '请填写', trigger: 'blur' }, { validator: validPhone, trigger: 'blur' }],
        needLeaveProvince: [{ required: true, message: '请选择是否出省', trigger: 'change' }],
        applyReason: [{ required: true, message: '请输入申请原因', trigger: 'blur' }],
        nextAuditUserName: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
        auditPersonId: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
        lastUserFlag: [{ required: true, message: '请选择是否结束审核', trigger: 'change' }],
      },
      id: '',
      type: '',
      actionType: '',
      show: false,
      // userInfoList: [],
      activeName: '',
      auditInfo: {
        auditProcessEntityList: [],
        createTime: '',
        applyUser: '',
        auditPerson: '',
        approvalFlag: false
      }
    }
  },
  mounted() {
    this.queryList()
  },
  methods: {
    handleStatus(creatUser) {
     let userName = JSON.parse(localStorage.getItem('jiadingFangwu_userInfo')).userName
     if (userName === creatUser) {
      this.statusOptions = [
        {
          value: '1',
          label: '通过'
        },
        {
          value: '2',
          label: '拒绝'
        },
        {
          value: '3',
          label: '转办'
        },
      ]
     }
    },
    handleRemark(val) {
      if (val === '1') {
        this.info.remark = '同意'
      } else if (val === '3') {
        this.info.remark = '转办'
      } else {
        this.info.remark = ''
      }
    },
    // 强制更新测试文本信息框的值
    changeMessage() {
      this.$forceUpdate()
    },
    // async queryList() {
    //   let res = await queryUserInfo({
    //     pageNum: 1,
    //     pageSize: 9999,
    //   })
    //   if (res.code === 0) {
    //     this.userInfoList = res.result.records
    //   }
    // },
    showDetails(type, id, activeName) {
      this.type = type
      this.show = true
      this.activeName = activeName
      if (id) {
        this.getDetails(id)
      }
    },
    getDetails(id) {
      this.id = id
      getApplyDetail({ id }).then(res => {
        const { code, result } = res
        if (code !== 0) return
        this.handleStatus(result.createUser)
        this.info = {
          applyContent: result.applyContent,
          applyTitle: result.applyTitle,
          eventId: result.eventId,
          lastUserFlag: result.lastUserFlag,
          nextAuditUserName: result.nextAuditUserName,
          auditPersonId: result.auditPersonId,
          status: result.approvalFlag === true ? '' : result.status,
        }
        this.timeValue = [result.begin, result.end]
        this.auditInfo = {
          auditProcessEntityList: result.auditProcessEntityList,
          createTime: result.createTime,
          applyUser: result.applyUser,
          auditPerson: result.auditPerson,
          approvalFlag: result.approvalFlag
        }
        if (this.type === 'new' && this.info && this.info.auditPersonId && result.status === 10) {
          this.info.auditPersonId = ''
        }
      })
    },
    close() {
      this.show = false
      this.timeValue = []
      this.info = {
        applyContent: '',
        applyTitle: '',
        eventId: '',

        lastUserFlag: '',
        nextAuditUserName: '',
        auditPersonId: '',
      }
      this.id = ''
      this.auditInfo = {
        auditProcessEntityList: [],
        createTime: '',
        applyUser: '',
        auditPerson: '',
        approvalFlag: false
      }
    },
    addEventForm() {
      this.$refs.form.validate(async (vaild) => {
        if (vaild) {
          let res = {}
          console.log(this.info);
          if (this.actionType === 'new') {
            let params = {
              ...this.info
            }
            delete params.eventId
            delete params.lastUserFlag
            delete params.nextAuditUserName
            res = await submitApply(params)
          }
          if (this.actionType === 'update') {
            let params = {
              id: this.id,
              ...this.info,
              status: 0
            }
            delete params.nextAuditUserName
            res = await update(params)
          }
          if (this.auditInfo.approvalFlag) {
            res = await auditAndNextUser({
              id: this.id,
              remark: this.info.remark,
              status: this.info.status,
              lastUserFlag: this.info.lastUserFlag,
              nextAuditUserName: this.info.nextAuditUserName,
            })
          }
          const { code, message } = res
          if (code !== 0) {
            this.$message.error(message)
            return
          }

          this.$message.success('提交成功！')
          this.$emit('addSuccess')
          this.close()
        }
      })
    },
    async addStagingForm() {
      this.$refs.form.validate(async (vaild) => {
        if (vaild) {
          let params = { ...this.info }
          delete params.lastUserFlag
          delete params.nextAuditUserName
          let res = await stagingApply(params)
          const { code, message } = res
          if (code !== 0) {
            this.$message.error(message)
            return
          }
          this.$message.success('暂存成功！')
          this.$emit('addSuccess')
          this.close()
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  min-width: 540px;
  width: 50%;
}
</style>
